import React from 'react';
import CustomCursor from '../../Global/Cursor';
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header5";
import Banner from '../MainHomeFive/Banner';
import Aboutsec from '../MainHomeFive/Aboutsec';
import Servicesec from '../MainHomeFive/Servicesec';
import Process from '../MainHomeFive/Process';
import Testinomial from '../MainHomeFive/Testinomial';
import Whychooseus from '../MainHomeFive/Whychooseus';
import Pricing from '../MainHomeFive/Pricing';
import Blog from '../MainHomeFive/Blog';
import Partner from '../MainHomeFive/Partner';
import Footer from '../../Global/Footer5';
import Gototop from '../../Global/GoToTop';
const Main = () => {
  return (
    <>
      <CustomCursor />
      <Preloader />
      <Header />
      <Banner />
      <Aboutsec />
      <Servicesec />
      <Process />
      <Testinomial />
      <Whychooseus />
      <Pricing />
      <Blog />
      <Partner />
      <Footer />
      <Gototop />

    </>
  )
}

export default Main;
